












import Vue, { PropType } from 'vue';

const labelType = ['unseen', 'unreplied'];

export default Vue.extend({
  name: 'GChatLabel',
  props: {
    label: {
      type: String as PropType<string>,
      validator: (prop: string) => labelType.includes(prop),
    },
  },
});
